module.exports = __webpack_public_path__ + "img/627.13d08c53.png";